module.exports = __webpack_public_path__ + "static/media/Meds.0a1f9dc8.svg";